module.exports = __webpack_public_path__ + "static/12-350598a7f6931bef0eef1343256eed23.png";